import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { Button } from 'ustore-ui';

import { CustomInputComponent } from '../../../../shared/components/custom-input/custom-input.component';
import { PasswordRequirementsComponent, PasswordRequirements } from '../../../../shared/components/password-requirements/password-requirements.component';
import { I18nPipe } from '../../../../shared/pipes/i18n.pipe';

@Component({
  selector: 'umkt-register-step3',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, Button, CustomInputComponent, PasswordRequirementsComponent, I18nPipe],
  templateUrl: './register-step3.component.html',
  styleUrls: [
    '../../../../../assets/style/login-register.component.scss',
    '../../register.component.scss'
  ]
})
export class RegisterStep3Component {
  @Input() step3Form!: FormGroup;
  @Input() passwordRequirements!: PasswordRequirements;
  @Input() loading = false;

  @Input() submitRegistration!: () => void;
  @Input() preventLeadingSpace!: (event: KeyboardEvent) => void;
  @Input() goToLogin!: () => void;

  @ViewChild('passwordInput') passwordInput!: CustomInputComponent;
  @ViewChild('confirmPasswordInput') confirmPasswordInput!: CustomInputComponent;

  onPasswordToggle(isVisible: boolean): void {
    if (this.passwordInput) {
      this.passwordInput.setPasswordVisibility(isVisible);
    }
    if (this.confirmPasswordInput) {
      this.confirmPasswordInput.setPasswordVisibility(isVisible);
    }
  }
}


